import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import { categoryNotActive } from '../../assets/images';
import {
	TUNING_STUDIO_CARD_HEIGHT,
	TUNING_STUDIO_CARD_WIDTH,
} from '../MenuItem/MenuItem.model';

const StyledContainer = styled.div``;

const StyledListWrapper = styled.div`
	display: flex;
	gap: 20px;
	align-items: center;
`;

const StyledHorizontalList = styled.div<{ $isFull?: boolean }>`
	display: flex;
	align-items: center;
	padding-left: ${({ $isFull }) => ($isFull ? '60px' : '0')};
	overflow-x: scroll;

	&::-webkit-scrollbar {
		display: none;
	}

	@property --leftFade {
		syntax: '<length>';
		inherits: false;
		initial-value: 0px;
	}

	-webkit-mask-image: linear-gradient(
		to right,
		transparent 0,
		black var(--leftFade),
		black 100%
	);
	mask-image: linear-gradient(
		to right,
		transparent 0,
		black var(--leftFade),
		black 100%
	);

	-webkit-mask-repeat: no-repeat;
	mask-repeat: no-repeat;

	-webkit-mask-size: 100% 100%;
	mask-size: 100% 100%;

	transition: --leftFade 300ms ease;
`;

const StyledTitleContainer = styled.div<{ $isFull?: boolean }>`
	position: absolute;
	top: -50px;
	left: ${({ $isFull }) => ($isFull ? '60px' : '240px')};
	display: flex;
	align-items: center;
	width: auto;
	height: 30px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	padding: 0 10px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledCountContainer = styled.div`
	position: absolute;
	top: -50px;
	right: 60px;
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledArrowButton = styled.div`
	width: 30px;
	height: 30px;
	background-color: rgba(17, 19, 20, 0.98);
	border-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;
	cursor: pointer;

	.img-icon {
		background-color: #ffffff;
		transition: background-color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		.img-icon {
			background-color: #000000;
		}
	}
`;

const StyledCountValueContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	height: 30px;
	padding: 0 10px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;

		span {
			font-size: 14px;
			font-weight: 400;
			opacity: 0.5;
		}
	}
`;

const StyledNotActiveCategory = styled.div`
	width: ${TUNING_STUDIO_CARD_WIDTH}px;
	min-width: ${TUNING_STUDIO_CARD_WIDTH}px;
	height: ${TUNING_STUDIO_CARD_HEIGHT}px;
	border-radius: 10px;
	overflow: hidden;
	background-image: url(${categoryNotActive});
	background-size: cover;
	background-position: center;
`;

export {
	StyledArrowButton,
	StyledContainer,
	StyledCountContainer,
	StyledCountValueContainer,
	StyledHorizontalList,
	StyledListWrapper,
	StyledNotActiveCategory,
	StyledTitleContainer,
};
